module.exports = __webpack_public_path__ + "img/supplyBrain-hover.266f89ad.png";